module.exports = __webpack_public_path__ + "static/media/21_Maf_NuestroEquipo_CarlosElizarraraz.53cb0c77.png";